import React, { useState, useEffect, useRef, useCallback } from 'react';
import {MOUSE_DOWN_EVENT, RECIPE_INGREDIENT_TYPE_CEREAL_MIX} from '../../constant';
import { ChevronIcon } from '../../appearence/icons/chevron_icon';
import SelectWithTokensActiveItem from '../../shared/SelectWithTokensActiveItem';
import SelectWithTokensInput from '../../shared/SelectWithTokensInput';
import SelectWithTokensSelectList from '../../shared/SelectWithTokensSelectList';
import { productsStorage } from '../../services/productsStorage';
import { useTranslation } from 'react-i18next';
import { PlusIcon } from '../../appearence/icons/plus_icon';
import CreateCerealMixBlock from '../preferences/CreateCerealMixBlock';
import { preferenceCerealMixSelectService } from '../../services/preferenceCerealMixSelectService';
import { Button } from '@chapche/ui';

const checkSelectedForms = (selectWithTokensManager) => {
    return selectWithTokensManager.getCurrentItems() && selectWithTokensManager.getCurrentItems().length;
};

const IngredientHandler = ({ selectWithTokensManager }) => {
    const { i18n } = useTranslation();
    const [selectListIsOpen, setSelectListIsOpen] = useState(false);
    const [selectedListLength, setSelectedListLength] = useState();
    const [addNewCerealMixIsOpen, setAddNewCerealMixIsOpen] = useState(false);
    const wrapperRef = useRef();

    const openItemsList = () => {
        setSelectListIsOpen(true);
    };

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setSelectListIsOpen(false);
        }
    }, []);

    const changeSelected = () => {
        setSelectedListLength(selectWithTokensManager.getCurrentItems().length);
    };

    useEffect(() => {
        productsStorage.loadItems(() => {});
        document.addEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
        preferenceCerealMixSelectService.loadItems();
        selectWithTokensManager.registerItemsChangingObserver(changeSelected);
        selectWithTokensManager.loadItems();
        return () => {
            document.removeEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            selectWithTokensManager.unRegisterItemsChangingObserver(changeSelected);
        };
    }, []);

    const changeCerealMixBlockState = (value) => {
        setAddNewCerealMixIsOpen(value);
        selectWithTokensManager.deleteItem('', true);
    };

    const fillInput = () => {
        if (selectListIsOpen || selectWithTokensManager.getCurrentItems().length === 0) {
            return (
                <SelectWithTokensInput selectWithTokensManager={
                    selectWithTokensManager.getIngredientType() === RECIPE_INGREDIENT_TYPE_CEREAL_MIX && !addNewCerealMixIsOpen ?
                        preferenceCerealMixSelectService
                        :
                        selectWithTokensManager
                } />
            );
        }
        return null;
    };

    const fillListItems = () => {
        if (checkSelectedForms(selectWithTokensManager) && selectedListLength > 0) {
            return (
                <div className={`product__forms-list ${selectWithTokensManager.getCurrentItems().length === 0 ? 'product__forms-list_full-width' : ''}`}>
                    {selectWithTokensManager.getCurrentItems().map((it, index) => (
                        <React.Fragment key={it.itemId + 'ingredient' + index}>
                            <SelectWithTokensActiveItem
                                selectItem={it}
                                removeCallback={selectWithTokensManager}
                            />
                        </React.Fragment>
                    ))}
                    {fillInput()}
                </div>
            );
        }
        return fillInput();
    };

    return (
        <>
            <label className="block__text product__form-label recipe__ingredient">
                {selectWithTokensManager.getLabelValue && selectWithTokensManager.getLabelValue() ? 
                    <span className="product__form-label_text">
                        {selectWithTokensManager.getLabelValue()}
                    </span>
                    :
                    null}
                <div ref={wrapperRef}>
                    <div className="product__forms relative mt-0 flex min-h-[46px] w-full cursor-pointer flex-wrap items-start justify-between rounded-input border border-solid border-light-grey bg-white px-16 py-8" onClick={openItemsList} >
                        {fillListItems()}
                        <ChevronIcon nameOfClass={`product__forms-icon ${selectListIsOpen ? 'product__forms-icon_active' : ''}`} />
                    </div>
                    {selectListIsOpen ? 
                        <div className="product__forms-dropdown product__select-dropdown">
                            {addNewCerealMixIsOpen && selectWithTokensManager.getIngredientType() === RECIPE_INGREDIENT_TYPE_CEREAL_MIX ?
                                <CreateCerealMixBlock closeCallback={changeCerealMixBlockState} selectManager={selectWithTokensManager} />
                                :
                                <>
                                    <SelectWithTokensSelectList 
                                        selectWithTokensManager={selectWithTokensManager.getIngredientType() === RECIPE_INGREDIENT_TYPE_CEREAL_MIX ? preferenceCerealMixSelectService : selectWithTokensManager}
                                        include={true}/>
                                    {selectWithTokensManager.getIngredientType() === RECIPE_INGREDIENT_TYPE_CEREAL_MIX ?
                                        <Button
                                            variant="ghost"
                                            size="small"
                                            className="preference__mix w-full justify-between"
                                            onClick={() => changeCerealMixBlockState(true)}
                                        >
                                            {i18n.t('app.page.preference.addCerealMix')}
                                            <PlusIcon nameOfClass="preference__mix-plus ml-8" handleClick={() => null} />
                                        </Button>
                                        :
                                        null}
                                </>}
                        </div>
                        :
                        null}
                </div>
            </label>
        </>
    );
};

export default IngredientHandler;
